import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ButtonSize } from '../Fundamentals/Button';
import SpirisIcon from '../Fundamentals/Icon/SpirisIcon';
import SkynetIconButton from '../Fundamentals/IconButton/SkynetIconButton';
import routes from '../../Constants/routes';
import type { AnnouncementRelease } from './Announcement.types';
import './ReleaseAnnouncementBanner.css';

interface ReleaseAnnouncementBannerProps {
    announcement: AnnouncementRelease;
    onClose: () => void;
}

const ReleaseAnnouncementBanner = ({ announcement, onClose }: ReleaseAnnouncementBannerProps) => {
    const { t } = useTranslation();

    return (
        <div className="release-announcement-banner position-relative d-flex align-items-center justify-content-center gap-8 px-32" role="status">
            <SpirisIcon name="info" size="sm" filled />
            <span>
                <strong>{t('announcement.newRelease')}</strong> {announcement.title}
            </span>
            <Link to={routes.versionArchiveDetails(announcement.id)} onClick={onClose} className="d-inline-flex align-items-center gap-4 ml-8">
                {t('announcement.readMore')}
                <SpirisIcon name="arrow-right" size="sm" />
            </Link>
            <SkynetIconButton icon="close" size={ButtonSize.SMALL} label={t('announcement.dismiss') ?? ''} onClick={onClose} className="release-announcement-banner-close" />
        </div>
    );
};

export default ReleaseAnnouncementBanner;
